import React from "react";
import "./NotFound.css";

export default () => (
  <div className="NotFound">
    <h3>
      Sorry, We have an Internal Server Error. Please try again and if it's
      still doesn't work, please contact us at:{" "}
      <a href="mailto:support@skylinesoft.com">support@skylinesoft.com</a>
    </h3>
  </div>
);
